<template> 
  <div id="app" :class="{breadcrumbopen: breadcrumbs.length > 1}">
    <div class="shutdown" v-if="system && system.status === '2'">
      <div class="shutdown-icon"></div>
      <div class="shutdown-message" v-html="$t('message.systemDown')"></div>
    </div>
    <div class="header" v-if="system">
      <nav class="nav-main" :class="{open: navMobile}">
        <a @click="navigate('/start', 0, 'start')" :class="{ active : isInRoute('start') }">{{$t('message.start')}}</a>
        <a @click="navigate('/belts', 0, 'belts')" :class="{ active : isInRoute('belt') }">{{$t('message.beltGrades')}}</a>
        <a @click="navigate('/countries', 0, 'countries')" :class="{ active : isInRoute('countr') }">{{$t('message.countries')}}</a>
        <a @click="navigate('/dojos', 0, 'dojos')" :class="{ active : isInRoute('dojo') }">Dojos</a>
        <a @click="navigate('/events', 0, 'events')" :class="{ active : isInRoute('event') }">Events</a>
        <a @click="navigate('/rankings', 0, 'rankings')" :class="{ active : isInRoute('ranking') }">{{$t('message.rankings')}}</a>
        <a @click="navigate('/results', 0, 'results')" :class="{ active : isInRoute('results') }">{{$t('message.results')}}</a>
        <a @click="navigate('/about', 0, 'about')" :class="{ active : isInRoute('about') }">{{$t('message.about')}}</a>
      </nav>
      
      <div class="header-system" v-if="system.status === '1'" @click="systemInfoOpen = !systemInfoOpen"></div>
      <div class="header-lang-btn" v-on:click="langSelect = !langSelect" :class="{inactive: langSelect}">{{lang}}</div>
      <div class="header-lang-list" v-if="langSelect">
        <div class="header-lang-list-item" v-on:click="setLang('de')" v-if="lang != 'de'">de</div>            
        <div class="header-lang-list-item" v-on:click="setLang('en')" v-if="lang != 'en'">en</div>                    
        <div class="header-lang-list-item" v-on:click="setLang('it')" v-if="lang != 'it'">it</div>                    
      </div>
      <div class="btn-nav-mobile" v-on:click="navMobile = !navMobile"></div>      
    </div>
    <div class="breadcrumbs-outer" v-if="breadcrumbs.length > 1">
      <nav class="breadcrumbs">
        <a v-for="(link, index) in breadcrumbs" @click="navigate(link.route, index, link.name)" :key="index">
          {{link.name}}
        </a>
      </nav> 
    </div>  
    <div class="system-info" v-if="systemInfoOpen" @click="systemInfoOpen = false">
      <div class="system-info-anim"></div>
      <div class="system-info-message">{{$t('message.systemUpdating')}}</div>
    </div>  
    <div class="content" v-if="initialized">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div class="footer">
      <a href="https://www.wkuworld.com" target="_blank">WKU WORLD</a> | <a href="https://www.wkuworld.com/privacy-policy/" target="_blank">{{$t('message.privacy')}}</a> | <a href="https://www.wkuworld.com/imprint/" target="_blank">{{$t('message.imprint')}}</a> | <a href="https://www.koordinauten.de" target="_blank">powered by Koordinauten</a> 
    </div>  
    <cookie-law theme="blood-orange" :buttonText="$t('message.gotIt')">
      <div slot="message">
        {{$t('message.cookieInfo')}}<a href="https://www.wkuworld.com/privacy-policy/" target="_blank">{{$t('message.learnMore')}}</a>
      </div>
    </cookie-law>
  </div>  
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data: function () {
    return {
      systemInfoOpen: false,
      langSelect: false,
      lang: 'en',
      navMobile: false,
      config: {
        API: {}
      },
      initialized: false
    }
  },
  methods: {
    isInRoute: function (name) {
      if (name === 'start' && this.$route.path === '/') return true
      return this.$route.path.split('/')[1].includes(name)
      // return this.$route.path + name
    },
    navigate: function (target, level, name) {
      if (level < this.breadcrumbs.length - 1 || level === 0) {
        if (!name) {
          name = target
        }
        var breadcrumb = {
          name: name,
          route: target
        }
        this.$store.commit('CUT_BREADCRUMBS', level)
        this.$store.commit('ADD_BREADCRUMB', breadcrumb)
        // this.$router.replace(target)
        // window.location.href = './#/' + breadcrumb.route
        this.$router.push({path: breadcrumb.route})
      }
    },
    setLang: function (val) {
      this.langSelect = false
      this.lang = val
      this.$i18n.locale = val
      this.$moment.locale(val)
    },
    getConfig: function () {
      this.$store.dispatch('getConfig').then(() => { 
        this.initialized = true
        this.getSystem()
      })
    },
    getSystem: function () {
      this.$store.dispatch('getSystem').then(() => { 
        // this.initialized = true        
      })
    }
  },
  computed: {
    history: function () {
      return window.history.length
    },
    route: function () {
      return this.$route.path
    },
    ...mapGetters({
      breadcrumbs: 'breadcrumbs',
      system: 'system'
    })
  },
  watch: {
    $route: function () {
      // TRAP HACKERS
      if (this.$route.path.includes('wp-admin')) {
        window.location = 'https://www.wku-members.de/404/404-notfound.php'
      }
      this.navMobile = false
      // repair breadcrumbs if back button got used
      if (this.breadcrumbs.length > 0) {
        if (this.breadcrumbs[this.breadcrumbs.length - 1].route !== this.route) {
          this.$store.commit('CUT_BREADCRUMBS', this.breadcrumbs.length - 1)
          console.log('CUT')
        }
      }
    }
  },
  created: function () {
    this.getConfig()
    // catch back
    window.onpopstate = function (event) {
      console.log('location: ' + document.location + 'state: ' + JSON.stringify(event.state))
    }
  }
}
</script>
<style>
@import "./assets/css/wku-members.scss"
</style>
